import { Vocabulary } from "./types";

const architecture: Vocabulary = {
  key: 'architecture',
  label: 'Architecture',
  words: [
    'business process',
    'consumer',
    'context',
    'decoupling',
    'enterprise-level',
    'facilitate',
    'focus',
    'hyper-personalization',
    'impacts',
    'integration layer',
    'journey',
    'lifecycle',
    'mindset',
    'off-line',
    'omni-channel',
    'orchestration',
    'ownership',
    'paradigm',
    'positioning',
    'proactive',
    'provider',
    'refactoring',
    'relevance',
    'restructuring',
    'reusability',
    'scalable',
    'shared',
    'strategy',
    'timeline'
  ]
};

const business: Vocabulary = {
  key: 'business',
  label: 'Business',
  words: [
    'Ballpark',
    'Best practice',
    'Blamestorming',
    'Boil the ocean',
    'Brainstorming',
    'Core compentency',
    'Empowering',
    'Gap analysis',
    'Goal-oriented',
    'Impact assessment',
    'Innovative',
    'Inshore',
    'Lean & mean',
    'Leverage',
    'Mindset',
    'Mindshare',
    'Mission statement',
    'Open door',
    'Out of the loop',
    'Out of the loop',
    'Paradigm shift',
    'Proactive',
    'Projection',
    'Restructuring',
    'ROI',
    'Stakeholders',
    'Team building'
  ]
};


export const vocabularies: Vocabulary[] = [ architecture, business ];
